export const CHART_TYPE = {
  TIMESERIES: "timeseries",
  HISTOGRAM: "histogram",
  BOXPLOT: "boxplot",
  SCATTER: "scatter"
}

export const DATA_SAMPLING = {
    DAY : '1m',
    WEEK: '5m',
    MONTH: '10m'
}

export const DB_ICONS = {
  CROSSHAIR: 'CROSSHAIR',
  ZOOM_IN: 'ZOOMIN',
  ZOOM_RESET: 'ZOOMRESET',
  LAYOUT_RESET: 'LAYOUTRESET',
  DATA: 'DATA',
  DOWNLOAD:'DOWNLOAD'
}

export const LAYOUTS = {
  LOCATION: 'LOCATION',
  VEHICLE: 'VEHICLE',
  IMU: 'IMU',
  TELEMETRY: 'TELEMETRY',
  MOTOR: 'MOTOR',
  BATTERY: 'BATTERY',
  BATTERYCELL: 'BATTERYCELL'
}

export const DB_DATA_FIELDS = {
    IMU:{
      title: "Accelerometer",
      value: "imu",
      children: [
        {
          title: "Accel X Axis",
          value: "accel_x_axis",
          unit: "°"
        },
        {
          title: "Accel Y Axis",
          value: "accel_y_axis",
          unit: "°"
        },
        {
          title: "Accel Z Axis",
          value: "accel_z_axis",
          unit: "°"
        },
        {
          title: "Gyro X Axis",
          value: "gyro_x_axis",
          unit: "°"
        },
        {
          title: "Gyro Y Axis",
          value: "gyro_y_axis",
          unit: "°"
        },
        {
          title: "Gyro Z Axis",
          value: "gyro_z_axis",
          unit: "°"
        },
        {
          title: "AI Lean Angle",
          value: "ai_lean_angle",
          unit: "°"
        },
      ]
    },
    TELEMETRY: {
      title: "Telemetry",
      value: "telemetry",
      children: [
        {
          title: "AI System Voltage",
          value: "ai_system_voltage",
          unit: "V"
        },
        {
          title: "AI Temperature",
          value: "ai_temperature",
          unit: "℃"
        },
        {
          title: "AI Voltage Input",
          value: "ai_voltage_input",
          unit: "V"
        },
        {
          title: "AI VBuck ",
          value: "ai_vbuck",
          unit: ""
        },
      ],
    },
    MOTOR: {
      title: "Motor",
      value: "motor",
      children: [
        {
          title: "Motor Speed",
          value: "motor_speed",
          unit: "rpm"
        },
        {
          title: "Motor Temperature",
          value: "motor_temperature",
          unit: "℃"
        },
        {
          title: "DC Current",
          value: "motor_dc_current",
          unit: "A"
        },
        {
          title: "DC Voltage",
          value: "motor_dc_voltage",
          unit: "V"
        },
        {
          title: "MCS Temperature",
          value: "motor_mcs_temperature",
          unit: "℃"
        },
        {
          title: "Motor Regeneration",
          value: "motor_regeneration",
          unit: "A"
        },
      ],
    },
    BATTERY: {
      title: "Battery",
      value: "battery",
      children: [
        {
          title: "Battery Voltage",
          value: "battery_volt",
          unit: "V"
        },
        {
          title: "Battery Current",
          value: "current",
            unit: "A"
        },
        {
          title: "SOC",
          value: "soc",
          unit: "%"
        },
        {
          title: "SOH",
          value: "soh",
          unit: "%"
        },
        {
          title: "Temperature Max",
          value: "temperature_max",
          unit: "℃"
        },
        {
          title: "Temperature Min",
          value: "temperature_min",
          unit: "℃"
        },
        {
          title: "Mosfet Temperature",
          value: "mosfet_temperature",
          unit: '℃'
        },
      ],
    },
};

export const LOCATION_FIELDS = {
  title: "Location",
  value: "location",
  children: [
    {
      title: "GPS Speed",
      value: "speed",
      unit: "km/h"
    },
    {
      title: "Altitude",
      value: "altitude",
      unit: "m"
    },
    {
      title: "Latitude",
      value: "latitude",
      unit: "deg"
    },
    {
      title: "Longitude",
      value: "longitude",
      unit: "deg"
    },
  ]
}
  